import { c as _c } from "react/compiler-runtime";
import { PERIOD_LABELS } from "@/helpers/Helpers";
import type { Period } from "@/helpers/Types";
export default function CreateWaveDatesEndDateSelectPeriodItem(t0) {
  const $ = _c(15);
  const {
    period,
    activePeriod,
    onPeriodSelect
  } = t0;
  const isActive = activePeriod === period;
  const buttonClasses = isActive ? "" : "tw-bg-transparent";
  const labelClasses = isActive ? "tw-font-semibold tw-text-primary-400" : "tw-font-medium tw-text-white";
  let t1;
  if ($[0] !== onPeriodSelect || $[1] !== period) {
    t1 = () => onPeriodSelect(period);
    $[0] = onPeriodSelect;
    $[1] = period;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `${buttonClasses} hover:tw-bg-iron-700 tw-py-3 tw-w-full  tw-border-none tw-text-left tw-flex tw-items-center tw-justify-between tw-text-white tw-rounded-lg tw-relative tw-cursor-pointer tw-select-none tw-px-2 focus:tw-outline-none focus:tw-ring-1 focus:tw-ring-primary-400 tw-transition tw-duration-300 tw-ease-out`;
  const t3 = `${labelClasses} tw-text-base`;
  const t4 = PERIOD_LABELS[period];
  let t5;
  if ($[3] !== t3 || $[4] !== t4) {
    t5 = <span className={t3}>{t4}</span>;
    $[3] = t3;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== isActive) {
    t6 = isActive && <svg className="tw-h-5 tw-w-5 tw-ml-2 tw-text-primary-400 tw-transition tw-duration-300 tw-ease-out" viewBox="0 0 24 24" fill="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"><path d="M20 6L9 17L4 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>;
    $[6] = isActive;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t2 || $[9] !== t5 || $[10] !== t6) {
    t7 = <div className={t2}>{t5}{t6}</div>;
    $[8] = t2;
    $[9] = t5;
    $[10] = t6;
    $[11] = t7;
  } else {
    t7 = $[11];
  }
  let t8;
  if ($[12] !== t1 || $[13] !== t7) {
    t8 = <li className="tw-h-full" onClick={t1}>{t7}</li>;
    $[12] = t1;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  return t8;
}